export default "__VITE_ASSET__5EW3E3KY__"